import { render, staticRenderFns } from "./WorkBreadcrumbs.vue?vue&type=template&id=6e60725a&scoped=true"
import script from "./WorkBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./WorkBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./WorkBreadcrumbs.vue?vue&type=style&index=0&id=6e60725a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e60725a",
  null
  
)

export default component.exports